import { notForPreview } from 'widget/utils/not-for-preview';

import { openModal, closeCatcher, isClose } from 'shared/components/modal/modal';
import { storeForReload } from 'widget/utils/reload';
import { EmptyModalHeader } from 'shared/components/modal/header/header';

import { PAYMENT_TYPE } from 'shared/constants/payments';
import PaymentForm from './payment-form';

import styles from './payments.styl';


const storeDataForReload = ({ paymentType, selectedVideoId }) => {
  storeForReload({
    openedModalType: paymentType,
    selectedVideoId,
  });
};

export const openSubscription = notForPreview(function (biEvent) {
  openModal({
    Header: EmptyModalHeader,
    windowClassName: styles['auth-window'],
    className: styles['auth-modal'],
    contentClassName: styles['auth-modal-content'],
    closeOnOverlayClick: true,
    content: <PaymentForm paymentType={PAYMENT_TYPE.SUBSCRIPTION}
                          onBeforePageRefresh={storeDataForReload} />,
  })
    .catch(reason => {
      if (!isClose(reason)) {
        return Promise.reject(reason);
      }
      biEvent('widget.subscriptionPopUp.Completed', { result: 'canceled', errorMsg: '' });
    });
});


export const openPurchase = notForPreview(function (videoId) {
  openModal({
    Header: EmptyModalHeader,
    windowClassName: styles['auth-window'],
    className: styles['auth-modal'],
    contentClassName: styles['auth-modal-content'],
    closeOnOverlayClick: true,
    content: (
      <PaymentForm paymentType={PAYMENT_TYPE.PURCHASE}
                   videoId={videoId}
                   onBeforePageRefresh={storeDataForReload} />
    ),
  })
    .catch(closeCatcher);
});


export const openRent = notForPreview(function (videoId) {
  openModal({
    Header: EmptyModalHeader,
    windowClassName: styles['auth-window'],
    className: styles['auth-modal'],
    contentClassName: styles['auth-modal-content'],
    closeOnOverlayClick: true,
    content: (
      <PaymentForm paymentType={PAYMENT_TYPE.RENT}
                   videoId={videoId}
                   onBeforePageRefresh={storeDataForReload} />
    ),
  })
    .catch(closeCatcher);
});



// WEBPACK FOOTER //
// ./src/widget/components/payments/payments.js